<template>
  <div class="survey__wrapper">
    <div class="detail">
      <div>
        <strong>{{ message }}</strong>
        <v-chip v-if="isDefault" color="primary" outline small style="font-size: 12px">{{
          $t('set_default')
        }}</v-chip>
      </div>
      <small>{{ $t('update_at') }}: {{ updatedAt | DateFormat('DD/MM/YYYY hh:mm A') }}</small>
    </div>
    <div class="action">
      <v-btn icon outline color="primary" class="ma-0" @click="showPreview = true">
        <v-icon small>visibility</v-icon>
      </v-btn>
      <template v-if="isEdit">
        <v-btn icon outline color="primary" class="ma-0" @click="$emit('edit')">
          <v-icon small>edit</v-icon>
        </v-btn>
        <v-btn icon outline color="primary" class="ma-0" @click="$emit('delete')">
          <v-icon small>delete</v-icon>
        </v-btn>
      </template>
    </div>
    <PreviewMessage v-if="showPreview" :messages="previewMessage" @close="showPreview = false" />
  </div>
</template>
<script>
import PreviewMessage from '@/components/elements/PreviewMessage'
export default {
  components: { PreviewMessage },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    },
    buttonName: {
      type: String,
      default: ''
    },
    surveyId: {
      type: String,
      default: ''
    },
    createdAt: {
      type: String,
      default: ''
    },
    updatedAt: {
      type: String,
      default: ''
    },
    isDefault: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showPreview: false
    }
  },
  computed: {
    previewMessage() {
      return [
        [
          {
            text: this.message,
            buttons: [
              {
                title: this.buttonName
              }
            ],
            type: 'button'
          }
        ]
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.survey__wrapper {
  border: 1px solid #c1c1c1;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  border-radius: 8px;
  .detail {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    strong {
      color: #000;
    }
    small {
      color: #9e9e9e;
    }
  }
  .action {
    display: flex;
    flex-direction: row;
    gap: 8px;
    justify-content: flex-end;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/Setting/CustomerSupportService/SurveyCard.vue